import './Hero.css';

function Hero() {
  return (
    <div className="hero-section d-flex align-items-center justify-content-center text-center">
      <div className="container px-4">
        <div className="hero-content animate-fade-in mx-auto">
          <h1 className="mb-3">Creamos soluciones digitales a tu medida</h1>

          <div className="mb-4">
            <img src="/img/CodeNest_Dev_Neg.png" alt="Logo Code Nest" className="hero-logo" />
          </div>

          <p className="mb-4">Desarrollamos páginas web, apps y sistemas que hacen crecer tu negocio.</p>
          <a href="#contacto" className="btn btn-primary">Contáctanos</a>
        </div>
      </div>
    </div>
  );
}

export default Hero;
